import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["cssFn"];
/* eslint-disable @repo/internal/react/no-unsafe-overrides */
import React, { forwardRef } from 'react';
import { CustomItem as Custom } from '@atlaskit/menu';
import { baseSideNavItemStyle, overrideStyleFunction } from '../../common/styles';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';

// Dirty hack to get generics working with forward ref [1/2]

/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */
var CustomItem = /*#__PURE__*/forwardRef(
// Type needed on props to extract types with extract react types.
function (_ref, ref) {
  var cssFn = _ref.cssFn,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useShouldNestedEleme = useShouldNestedElementRender(),
    shouldRender = _useShouldNestedEleme.shouldRender;
  if (!shouldRender) {
    return null;
  }
  var cssOverride = overrideStyleFunction(baseSideNavItemStyle, cssFn);
  // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
  return /*#__PURE__*/React.createElement(Custom, _extends({
    ref: ref,
    cssFn: cssOverride
  }, rest));
}
// Dirty hack to get generics working with forward ref [2/2]
);
export default CustomItem;